import * as React from "react";

import { shipmentSelectorStore } from "./store/ShipmentSelectorStore";
import { ShipmentSelector } from "./ShipmentSelector";
import { Container } from "../Container";

interface IShipmentSelectorWidgetProps {
	onShipmentClick?: (shipmentId: string) => void;
}

export const ShipmentSelectorWidget = ({ onShipmentClick }: IShipmentSelectorWidgetProps): JSX.Element => (
	<Container store={shipmentSelectorStore}>
		<ShipmentSelector onShipmentClick={onShipmentClick}/>
	</Container>
);
